import { render, staticRenderFns } from "./WaveformCanvas.vue?vue&type=template&id=04b4a8e9&scoped=true&"
import script from "./WaveformCanvas.vue?vue&type=script&lang=js&"
export * from "./WaveformCanvas.vue?vue&type=script&lang=js&"
import style0 from "./WaveformCanvas.vue?vue&type=style&index=0&id=04b4a8e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b4a8e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
